import { Button } from './ui/button';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
  loading: boolean;
}

export default function ConfirmDeleteModal({ isOpen, onClose, onConfirm, itemName, loading }: ConfirmDeleteModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-semibold text-gray-800">Konfirmasi Hapus</h2>
        <p className="text-sm text-gray-600 mt-2">
          Apakah Anda yakin ingin menghapus <strong>{itemName || 'item ini'}</strong>? Tindakan ini tidak dapat
          dibatalkan.
        </p>
        <div className="mt-4 flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose}>
            Batal
          </Button>
          <Button variant="destructive" disabled={loading} onClick={onConfirm}>
            {loading ? 'Menghapus...' : 'Hapus'}
          </Button>
        </div>
      </div>
    </div>
  );
}
